import { render, staticRenderFns } from "./ClientVotesFilters.vue?vue&type=template&id=512ba1a1&"
import script from "./ClientVotesFilters.vue?vue&type=script&lang=js&"
export * from "./ClientVotesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports